
import { ESPUField } from '@/common/enum/spu';
import { ICarSPUField } from '@/common/interface/carSpu';
import { ECarSPUField } from '@/common/enum/carSpu';
import NameField from '@/components/carModule/fields/NameField.vue';
import FirstRegistrationDateField from '@/components/carModule/fields/FirstRegistrationDateField.vue';
import MileageField from '@/components/carModule/fields/MileageField.vue';
import CarLocationfield from '@/components/carModule/fields/CarLocationfield.vue';
import TransferTimesField from '@/components/carModule/fields/TransferTimesField.vue';
import UseTofield from '@/components/carModule/fields/UseTofield.vue';
import ColorField from '@/components/carModule/fields/ColorField.vue';
import InteriorColorField from '@/components/carModule/fields/InteriorColorField.vue';
import GearNameField from '@/components/carModule/fields/GearNameField.vue';
import VinCodeField from '@/components/carModule/fields/VinCodeField.vue';
import ExteriorInfoField from '@/components/carModule/fields/ExteriorInfoField.vue';
import LiterField from '@/components/carModule/fields/LiterField.vue';
import AccidentInfoField from '@/components/carModule/fields/AccidentInfoField.vue';
import HighlightsField from '@/components/carModule/fields/HighlightsField.vue';
import VehicleSourceProcedureInformationField from '@/components/carModule/fields/VehicleSourceProcedureInformationField.vue';
import VehicleSourceInformationField from '@/components/carModule/fields/VehicleSourceInformationField.vue';
import VehicleSourcePriceInformationField from '@/components/carModule/fields/VehicleSourcePriceInformationField.vue';
import InformationOnTheLocationOfTheVehicleSourceField from '@/components/carModule/fields/InformationOnTheLocationOfTheVehicleSourceField.vue';
import LicenseInformationModuleField from '@/components/carModule/fields/LicenseInformationModuleField.vue';
import DescriptionField from '@/components/carModule/fields/DescriptionField.vue';
import SwitchField from '@/components/carModule/fields/SwitchField.vue';
// import BrandCarSeriesModelsField from '@/components/carModule/fields/BrandCarSeriesModelsField.vue';
import ImagesField from '@/components/carModule/fields/ImagesField.vue';
import { CarSPU } from '@/models/car.model';
import ShopService from '@/services/shop.service';

import { City } from '@/common/interface';

import lazyInject from '@/di';
import SPUService from '@/services/spu.service';
import _ from 'lodash';
import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import { CarFieldFactory } from '@/models/carFieldFactory';

@Component({})
export default class SPUAudit extends Vue {
  toAuditForm: { [key: string]: any } = {};

  toAuditFormItems: ICarSPUField[] = [];

  toAuditSpu: CarSPU = new CarSPU();

  rawForm: { [key: string]: any } | null = null;

  rawSpu: CarSPU = new CarSPU();

  initSpuFields: ICarSPUField[] = CarFieldFactory.init({ spuType: 'audit' });

  @Prop({
    default: {},
  })
  readonly auditUpdateData!: { [key: string]: any };
  citys: City[] = [];

  options: any = [];

  @lazyInject(ShopService)
  shopService!: ShopService;

  @Prop()
  readonly rawData!: { [key: string]: any };

  @Watch('auditUpdateData', { deep: true })
  async watchAuditUpdateData() {
    if (!this.auditUpdateData) {
      this.toAuditForm = {};
      return;
    }

    const spu = CarSPU.form(this.auditUpdateData as any);
    this.toAuditSpu = spu;
    this.toAuditForm = this.initSpuForm(spu);

    // const shouldGetIndicativePrice = this.toAuditForm.category.id !== 0;

    const fields = await this.initSpuConfig();
    this.toAuditFormItems = [...fields];
  }

  @Watch('rawData', { deep: true })
  async watchRawData() {
    if (this.rawData == null) {
      return;
    }
    const rawSpu = CarSPU.form(this.rawData as any);
    this.rawSpu = rawSpu;
    this.rawForm = this.initSpuForm(rawSpu);
  }

  @lazyInject(SPUService)
  protected spuService!: SPUService;

  getComponent(type: ECarSPUField) {
    switch (type) {
      case ECarSPUField.NAME:
        return NameField;
      // case ECarSPUField.BRAND_CAR_SERIES_MODELS:
      //   return BrandCarSeriesModelsField;
      case ECarSPUField.FIRST_REGISTRATION_DATE:
        return FirstRegistrationDateField;
      case ECarSPUField.MILEAGE:
        return MileageField;
      case ECarSPUField.CAR_LOCATION:
        return CarLocationfield;
      case ECarSPUField.TRANSFER_TIMES:
        return TransferTimesField;
      case ECarSPUField.USE_TO:
        return UseTofield;
      case ECarSPUField.COLOR:
        return ColorField;
      case ECarSPUField.INTERIOR_COLOR:
        return InteriorColorField;
      case ECarSPUField.GEAR_NAME:
        return GearNameField;
      case ECarSPUField.VIN_CODE:
        return VinCodeField;
      case ECarSPUField.EXTERIOR_INFO:
        return ExteriorInfoField;
      case ECarSPUField.LITER:
        return LiterField;
      case ECarSPUField.ACCIDENT_INFO:
        return AccidentInfoField;
      case ECarSPUField.HIGHLIGHTS:
        return HighlightsField;
      case ECarSPUField.VEHICLE_SOURCE_PROCEDURE_INFORMATION:
        return VehicleSourceProcedureInformationField;
      case ECarSPUField.VEHICLE_SOURCE_INFORMATION:
        return VehicleSourceInformationField;
      case ECarSPUField.VEHICLE_SOURCE_PRICE_INFORMATION:
        return VehicleSourcePriceInformationField;
      case ECarSPUField.INFORMATION_ON_THE_LOCATION_OF_THE_VEHICLE_SOURCE:
        return InformationOnTheLocationOfTheVehicleSourceField;
      case ECarSPUField.LICENSE_INFORMATION_MODULE:
        return LicenseInformationModuleField;
      case ECarSPUField.DESCRIPTION:
        return DescriptionField;
      case ECarSPUField.AUTOMATIC_SHELVING:
        return SwitchField;
      case ECarSPUField.AUTOMATIC_DELISTING:
        return SwitchField;
      case ECarSPUField.CAR_IMAGES:
        return ImagesField;
      case ECarSPUField.VERIFICATION_IMAGES:
        return ImagesField;
      case ECarSPUField.HEADER_IMAGE:
        return ImagesField;
      case ECarSPUField.REFIT_CHARGE:
        return MileageField;
      case ECarSPUField.EVALUATION_PRICE:
        return MileageField;
      default:
        return '';
    }
  }

  /** 获取城市里列表 */
  async getCityList() {
    const res = await this.shopService.getAllRegion();
    if (res) {
      this.options = res;
    } else {
      this.options = [];
    }

    const localCity = localStorage.getItem('localCity');
    if (localCity) {
      this.citys = JSON.parse(localCity);
    } else {
      const payload = {
        covered: true,
        joined: true,
        aggregation: false,
      };
      const response = (await this.shopService.getCityList(payload)) as unknown as {
        [key: string]: {
          province: City;
          city: City[];
        };
      };
      if (response) {
        const citys = Object.values(response)
          .map((item) => item.city)
          .reduce((prev, cur) => prev.concat(cur), []);
        localStorage.setItem('localCity', JSON.stringify(citys));
        this.citys = citys;
      } else {
        this.citys = [];
      }
    }
  }

  /**
   * @note 审核系统中对商品的审核并不会触发关于价格的验证器（只读查看模式），
   * 因此验证器内部选取商品送审或原始数据随选其一即可（新商品会没有原始数据，选择送审数据更为合适）。
   */
  vipPriceValidator(
    rule: { [key: string]: string | (() => boolean) },
    value: string,
  ) {
    const { originalPriceCent, products } = this.toAuditForm;

    if (products.length) {
      return +value < +this.toAuditForm.comboTotalPrice.originalPriceCent;
    } else {
      if (+value > 0 && (!originalPriceCent || isNaN(+originalPriceCent))) {
        return true;
      }
      return +value < +originalPriceCent;
    }
  }

  newUserPriceValidator(
    rule: { [key: string]: string | (() => boolean) },
    value: string,
  ) {
    const { vipPriceCent } = this.toAuditForm;
    if (!vipPriceCent || isNaN(+vipPriceCent)) {
      return true;
    }
    return +value < +vipPriceCent;
  }

  originalPriceValidator(
    rule: { [key: string]: string | (() => boolean) },
    value: string,
  ) {
    const { products } = this.toAuditForm;
    if (products.length) {
      return +this.toAuditForm.comboTotalPrice.originalPriceCent > 0;
    } else {
      return +value > 0;
    }
  }

  initSpuForm(spu: CarSPU) {
    const form: { [key: string]: any } = {};
    for (const [key, value] of Object.entries(spu)) {
      switch (key) {
        case ESPUField.EFFECTIVE_TIMES: {
          if (Number(value) > 1) {
            form.isCombo = true;
          } else {
            form.isCombo = false;
          }
          form[key] = value;
          break;
        }


        default: {
          form[key] = value;
          break;
        }
      }
    }

    return form;
  }

  async initSpuConfig() {
    const detail = _.cloneDeep(this.initSpuFields);
    return detail;
  }

  getToAuditData() {
    const data = JSON.parse(JSON.stringify(this.auditUpdateData));
    // console.log(data);
    // data.car_images = data.car_images.map((res: any) => res.id);
    // const headerImage = data.header_image.map((res: any) => res.id);
    // data.header_image = headerImage[0] || '';
    // data.verification_images = data.verification_images.map((res: any) => res.id);
    // const procureProof = data.procure_proof.map((res: any) => res.id);
    // data.procure_proof = procureProof[0] || '';
    return data;
  }

  mounted() {
    this.watchAuditUpdateData();
    this.watchRawData();
    this.getCityList();
  }

  deepEqual(obj1: any, obj2: any): boolean {
    // 如果两个对象引用相同，则直接返回 true
    if (!obj2 && !obj1) return true;
    if (obj1 === obj2) return true;

    // 如果不是对象或数组，或者一个为 null，另一个不为 null，则返回 false
    if (typeof obj1 !== 'object' || obj1 === null ||
      typeof obj2 !== 'object' || obj2 === null) {
      return false;
    }

    const keysA = Object.keys(obj1);
    const keysB = Object.keys(obj2);

    // 检查键的数量是否相等
    if (keysA.length !== keysB.length) return false;

    // 检查每一个键值是否相等
    for (const key of keysA) {
      if (!keysB.includes(key) || !this.deepEqual(obj1[key], obj2[key])) return false;
    }
    return true;
  }
}
